<template>
  <div class="infoEvent">
    <img id="logo"
      src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Delgado%20Calles%2FDetalles.svg?alt=media&token=e56ab053-b4ae-4288-99e7-ee512c898b5c"
      alt="" />
    <div class="title">
      <h2>Detalles del evento</h2>
    </div>
    <div class="branch">
      <img
        src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Delgado%20Calles%2Flineas.svg?alt=media&token=43296e1e-e0e5-4224-9f5f-1b37813efb1d"
        alt="" />
    </div>
    <!--  -->
    <div class="event">
      <div id="ceremonia">
        <h3>Lugar</h3>
      </div>
      <img :src="InfoEvent.FotoEvento" class="foto" alt="" />
      <p id="day" style="font-size: 1.5rem;">29 . junio . 2024</p>
      <h2 class="hour">3:30 pm</h2>
      <p style="font-weight: 700; text-align: center;  font-size: 1.2rem;">{{ InfoEvent.LugarEvento }}</p>
      <p style="text-align: center;  font-weight: 100; width: 70%;">
        {{ InfoEvent.IndicacionesEspecialesEvento }}
      </p>
      <div class="buttons">
        <button style="height: 3rem; font-size: 1.3rem; font-weight: 100;"
          @click="goToLink('https://maps.app.goo.gl/5cX3LNudA5csAc3F7')">
          Google
        </button>
        <button style="height: 3rem; font-size: 1.3rem; font-weight: 100;"
          @click="goToLink('https://ul.waze.com/ul?place=ChIJ4bNkW1DAYo8RXNsAajog-bs&ll=13.87672870%2C-89.67081080&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location')">
          Waze
        </button>
        <add-to-calendar-button proKey="c43f1888-2b41-446d-84a5-c0cb7cc1bd9d" />
      </div>
      <br>
      <img class="versiculos"
        src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Delgado%20Calles%2Fversiculo2.png?alt=media&token=c75c8aed-f6e5-403f-abfc-008af0544a3a"
        alt="">
      <br>
    </div>

    <!-- <div class="reception">
      <div>
        <h2>Recepción</h2>
      </div>
      <img :src="InfoEvent.FotoRecepcion" class="foto" alt="" />
      <p id="day">10 . Febrero . 2024</p>
      <h2 class="hour">{{ moment(InfoEvent.FechaHoraRecepcion, "LT") }}</h2>
      <p style="font-weight: 700;">{{ InfoEvent.LugarRecepcion }}</p>
      <p style="text-align: center; margin-left: 3rem; margin-right: 3rem; font-weight: 100;">
        {{ InfoEvent.IndicacionesEspacialesRecepcion }}
      </p>
      <p style="font-size: 1.3rem; font-weight: 500">hashtag evento</p>
      <p style="text-align: center">{{ InfoEvent.HashtagEvento }}</p>
      <div class="buttons">
        <button style="height: 3rem" @click="goToLink('https://maps.app.goo.gl/8UEGCvgLmfvTW9Dt8')">
          <font-awesome-icon :icon="['fas', 'map-location-dot']" /> Cómo Llegar
        </button>
        <button style="height: 3rem" @click="goToLink('https://ul.waze.com/ul?preview_venue_id=177471625.1774388568.2162904&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location')">
          <font-awesome-icon :icon="['fab', 'waze']" /> Cómo Llegar
        </button>
        <add-to-calendar-button proKey="ce948271-f5e5-4c07-afa4-6be58615cea6" />
      </div>
    </div> -->
    <div class="dresscode">
      <h2>Dress Code</h2>
      <img
        src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Delgado%20Calles%2FDress-code.svg?alt=media&token=b072465d-74e6-41d1-8a17-6236fb979ea6"
        style="width: 8rem" alt="" />
      <button class="buttonPinterest" @click="goToLink('https://pin.it/6RmfkCS1K')"><font-awesome-icon
          :icon="['fab', 'pinterest']" /> Mira algunas sugerencias aquí</button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import "add-to-calendar-button";

export default {
  name: "InfoEvento",
  props: {
    Code: {
      type: String,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      InfoEvent: {
        FechaHoraEvento: "2024-01-20T16:00:00.000Z",
        FechaHoraRecepcion: "2024-01-20T16:00:00.000",
      },
      diferencial: this.$route.query.id,
      key: "",
    };
  },
  methods: {
    GetInfoEvent() {
      let url = process.env.VUE_APP_API_DEV
        ? `${process.env.VUE_APP_API_DEV}Event/GetInfoEvent/${this.Code}`
        : `${process.env.VUE_APP_API_PRO}Event/GetInfoEvent/${this.Code}`;
      axios
        .get(url)
        .then((response) => (this.InfoEvent = response.data))
        .catch((err) => console.error(err));
    },

    moment: function (date, format) {
      var _date = new Date(date.replaceAll("T", " ").replaceAll(".000Z", ""));
      return moment(_date).locale("es-mx").format(`${format}`);
    },

    goToLink(link) {
      window.open(link, "_blank");
    },
  },
  created() {
    this.GetInfoEvent();
  },
};
</script>

<style scoped>
.versiculo {
  width: 25rem;
}

.infoEvent {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-column-gap: 10px;
  width: 75%;
  justify-items: center;
  color: var(--text);
}

.flower {
  grid-area: 1 / 1 / 2 / 2;
}

.title {
  grid-area: 2 / 1 / 3 / 2;
}

.branch {
  grid-area: 3 / 1 / 4 / 2;
}

.branch>img {
  width: 100%;
}

.subtitle {
  grid-area: 4 / 1 / 5 / 2;
}

#day {
  color: var(--text);
}

button {
  background: var(--btn);
  color: var(--btn-text);
  border-radius: 6px;
  box-shadow: var(--btn-shadow);
  height: 2.7rem;
  margin-top: 0.2rem;
  font-weight: 600;
  font-size: 16px;
}

button:hover {
  box-shadow: var(--btn-shadow-hover);
}

button:active {
  box-shadow: var(--btn-shadow-active);
}

.event {
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 10px;
  align-items: baseline;
  justify-items: center;
  width: 100%;
  grid-column: 1 / 2;
}

.foto {
  height: 15rem;
  width: 22rem
}

.reception {
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 10px;
  place-items: center;
  width: 100%;
  grid-column: 1 / 2;
}

.dresscode {
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 10px;
  place-items: center;
  width: 100%;
  grid-column: 1 / 2;
}

.buttons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 0px;
  height: 100%;
  padding-bottom: 1rem;
}

#rules {
  width: 30rem;
}

.day {
  font-weight: 100;
}

.buttons2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 0px;
  height: 100%;
  padding-bottom: 1rem;
}

h2 {
  font-family: var(--titulos);
  color: var(--title);
  font-size: 2.5rem;
}

h3 {
  font-family: var(--title);
  color: var(--title);
  font-size: 1.5rem;
  font-weight: 120;
}

.hour {
  font-family: 'Roboto';
  color: var(--title);
  font-size: 1.5rem;
  font-weight: 500;
}

#logo {
  width: 3rem;
  grid-column: 1 / 4;
  padding-top: 5%;
}


@media (max-width: 768px) {

  .buttonPinterest {
    height: 90%;
    width: 80%;
    margin-bottom: 1rem;
    font-weight: 500;
  }

  .versiculo {
    width: 25rem;
    padding-right: 6%;
  }

  .foto {
    width: 100%;
  }


  .infoEvent {
    grid-template-columns: 1fr;
    width: 100%;
  }

  .branch>img {
    width: 100%;
  }


  .event {
    grid-row-gap: 10px;
    padding-bottom: 3rem;
  }

  .reception {
    grid-row-gap: 10px;
  }

  .buttons {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 10px;
    height: 100%;
  }

  .buttons2 {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 10px;
    height: 100%;
  }

  button {
    display: block;
    margin: 0 auto;
    width: 12.5rem;
    height: 2rem;
  }

  #ceremonia {
    height: 2rem !important;
  }

  #logo {
    grid-column: 1 / 2;
  }

  #rules {
    width: 100%;
  }
}
</style>
